import { useMemo } from 'react';

import filter from '@Components/Grid/utils/filter';

export default function useFilters() {
  return useMemo(() => [
    filter.boolean('active', 'Active'),
    filter.boolean('isManagerAdmin', 'Manager admin'),
  ], [])
}
